import { useGetCurrentUserQuery } from "@/setup/frontend/api/apiHooks";
import type { FeatureFlagKey } from "./featureFlags";
import * as SentryReact from "@sentry/react";
import { useEffect } from "react";

export function useFeatureFlags() {
	const currentUser = useGetCurrentUserQuery();
	return currentUser.data?.featureFlags ?? {};
}

export function useFeatureFlag(flag: FeatureFlagKey) {
	const flags = useFeatureFlags();
	const value = flags[flag] ?? false;

	useEffect(() => {
		const integration =
			SentryReact.getClient()?.getIntegrationByName<SentryReact.FeatureFlagsIntegration>(
				"FeatureFlags",
			);
		if (integration) {
			integration.addFeatureFlag(flag, value);
		}
	}, [value]);

	return value;
}
